// Module
var code = "<svg viewBox=\"0 0 20 20\" fill=currentColor> <path d=\"M6 10a2 2 0 11-4 0 2 2 0 014 0zM12 10a2 2 0 11-4 0 2 2 0 014 0zM16 12a2 2 0 100-4 2 2 0 000 4z\"/> </svg> ";
// Exports
module.exports = code;